/* PDP -ugc1 Customer Reviews — self-contained (does not touch the shared
   component-product-reviews.js). Fetches ALL reviews once and sorts entirely
   client-side: Pinned always lead, Featured is ignored (the Worker pins
   Featured to the top of every server sort, which we deliberately override).
   Vanilla, no deps. */
(function () {
  'use strict';

  var WORKER = 'https://cakemiami-product-reviews.pavlovacake305.workers.dev';
  var SORTS = ['newest', 'photos_first', 'oldest'];
  var PAGE = 8;

  function stars(n) {
    var c = Math.max(0, Math.min(5, Math.round(Number(n) || 0)));
    return '★★★★★'.slice(0, c) + '☆☆☆☆☆'.slice(0, 5 - c);
  }
  function fmtDate(v) {
    if (!v) return '';
    var d = new Date(v);
    return isNaN(d.getTime()) ? '' : d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }
  function sizeImg(u, w) {
    return u && /[?&]w=\d+/.test(u) ? u.replace(/w=\d+/, 'w=' + w) : u;
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function dnum(r) {
    var t = new Date(r.submitted_at || 0).getTime();
    return isNaN(t) ? 0 : t;
  }
  function photoCount(r) {
    return (r.photo_urls || r.photos || []).length;
  }

  function init(root) {
    var handle = root.getAttribute('data-pug-handle');
    if (!handle) return;
    var list = root.querySelector('[data-pug-rev-list]');
    var empty = root.querySelector('[data-pug-rev-empty]');
    var error = root.querySelector('[data-pug-rev-error]');
    var more = root.querySelector('[data-pug-rev-more]');
    var sortWrap = root.querySelector('[data-pug-rev-sort]');
    var all = [];
    var mode = 'newest';
    var shown = PAGE;

    function setAll(sel, val) {
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = val; });
    }

    function renderSummary(s) {
      var n = Number(s.totalReviews || s.total || 0);
      var avg = Number(s.averageRating || s.average_rating || 0);
      var dist = s.ratingDistribution || s.rating_distribution || {};
      setAll('[data-pug-rev-avg]', avg > 0 ? avg.toFixed(1) : '—');
      setAll('[data-pug-rev-stars]', stars(avg));
      setAll('[data-pug-rev-count]', n + ' reviews');
      var html = [5, 4, 3, 2, 1].map(function (r) {
        var c = Number(dist[r] || dist[String(r)] || 0);
        var p = n > 0 ? Math.round((c / n) * 100) : 0;
        return '<div class="pug-histo-row"><span class="lbl">' + r + ' star</span>' +
          '<span class="pug-histo-track"><span class="pug-histo-fill" style="width:' + p + '%"></span></span>' +
          '<span class="pug-histo-val">' + c + '</span></div>';
      }).join('');
      root.querySelectorAll('[data-pug-rev-histo], [data-pug-rev-histo-m]').forEach(function (el) { el.innerHTML = html; });
      root.classList.add('is-ready');
    }

    function comparator() {
      if (mode === 'newest') return function (a, b) { return dnum(b) - dnum(a); };
      if (mode === 'oldest') return function (a, b) { return dnum(a) - dnum(b); };
      return function (a, b) { return ((photoCount(b) > 0 ? 1 : 0) - (photoCount(a) > 0 ? 1 : 0)) || (dnum(b) - dnum(a)); };
    }
    function sortedAll() {
      var cmp = comparator();
      // Pinned always lead; Featured intentionally has no effect here.
      return all.slice().sort(function (a, b) { return ((b.pinned ? 1 : 0) - (a.pinned ? 1 : 0)) || cmp(a, b); });
    }

    function card(rv) {
      var a = document.createElement('article');
      a.className = 'pug-rev-card' + (rv.pinned ? ' is-pinned' : '');
      if (rv.review_id) a.id = 'review-' + rv.review_id;
      var txt = rv.review_text || '';
      if (txt.length > 240) txt = txt.slice(0, 240) + '…';
      var badge = rv.pinned ? '<span class="pug-rev-badge">Pinned</span>' : '';
      var photos = (rv.photo_urls || rv.photos || []).slice(0, 6).map(function (u) {
        return '<a href="' + encodeURI(u) + '" target="_blank" rel="noopener noreferrer">' +
          '<img loading="lazy" src="' + encodeURI(sizeImg(u, 160)) + '" alt="Customer review photo"></a>';
      }).join('');
      a.innerHTML =
        '<div class="pug-rev-card-top"><span class="pug-rev-who">' + esc(window.transformReviewName(rv.reviewer_display_name, 'Cake Miami customer')) + '</span>' +
        '<span class="pug-rev-when">' + fmtDate(rv.submitted_at) + '</span></div>' +
        badge +
        '<div class="pug-rev-stars" aria-label="' + (Number(rv.rating) || 0) + ' out of 5 stars">' + stars(rv.rating) + '</div>' +
        '<p class="pug-rev-text">' + esc(txt) + '</p>' +
        (photos ? '<div class="pug-rev-photos">' + photos + '</div>' : '');
      return a;
    }

    function render() {
      var arr = sortedAll();
      list.textContent = '';
      arr.slice(0, shown).forEach(function (rv) { list.appendChild(card(rv)); });
      if (empty) empty.hidden = arr.length !== 0;
      if (more) more.hidden = shown >= arr.length;
    }

    function setSort(m) {
      if (SORTS.indexOf(m) === -1) return;
      mode = m;
      shown = PAGE;
      sortWrap.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b.getAttribute('data-sort') === m);
      });
      render();
    }

    if (sortWrap) {
      sortWrap.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-sort]');
        if (b) setSort(b.getAttribute('data-sort'));
      });
    }
    if (more) more.addEventListener('click', function () { shown += PAGE; render(); });

    var toggle = root.querySelector('[data-pug-rev-histo-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var hm = root.querySelector('[data-pug-rev-histo-m]');
        if (hm.hasAttribute('hidden')) { hm.removeAttribute('hidden'); toggle.textContent = 'Breakdown ⌃'; }
        else { hm.setAttribute('hidden', ''); toggle.textContent = 'Breakdown ⌄'; }
      });
    }

    // Stats (count + histogram).
    var statsReq = (window.CakeTrackReviewStats && typeof window.CakeTrackReviewStats.getStats === 'function')
      ? window.CakeTrackReviewStats.getStats(WORKER, handle)
      : fetch(WORKER + '/api/reviews/stats?product=' + encodeURIComponent(handle) + '&noCache=1', { cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); });
    statsReq.then(renderSummary).catch(function () { /* list still renders */ });

    // All reviews in one request; everything below is sorted/paginated client-side.
    fetch(WORKER + '/api/reviews/list?product=' + encodeURIComponent(handle) + '&limit=100&offset=0&sort=newest&noCache=1', { cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (p) {
        all = Array.isArray(p.reviews) ? p.reviews : [];
        if (error) error.hidden = true;
        render();
      })
      .catch(function () { if (error) error.hidden = false; });
  }

  function boot() { document.querySelectorAll('[data-pug-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pug-reviews]').forEach(init);
  });
})();
